<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="customer-cards-sidebar" position="left" lockedOpen="gt-md">
        <customer-details-sidebar [user]="user"></customer-details-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

<!--    <div id="changelog" class="page-layout simple fullwidth docs" style="overflow-y: scroll;">-->

        <!-- CONTENT -->
        <div class="center p-24" style="overflow-y: scroll;">

            <div>
                <div>
                    <button (click)="changeHistoryVisibility(true)" *ngIf="!visibleErrorHistory" mat-button
                            class="mr-8">{{'Show error logs'|translate}}</button>
                    <button (click)="changeHistoryVisibility(false)" *ngIf="visibleErrorHistory" mat-button
                            class="mr-8">{{'Hide error logs'|translate}}</button>
                </div>
                <mat-accordion>
                    <mat-expansion-panel *ngFor="let log of logs">

                        <mat-expansion-panel-header *ngIf="(log.errorLog && visibleErrorHistory) || (!log.errorLog)">
                            <mat-panel-title>
                                <span class="date" style="width: 200px;" [style]="log.errorLog?'color:red;':''">{{log.createdAt|date: 'dd.MM.y HH:mm:ss': 'UTC+' + log.timezoneOffset: locale}}</span>
                                <span class="version" *ngIf="log.errorLog" style="color: red;">{{log.description|translate|transformLog:log.params}}</span>
                                <span class="version" *ngIf="!log.errorLog">{{log.description|translate|transformLog:log.params}}</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="groups">

                            <div class="new">
                            <span class="title">
                                {{'Additional info'|translate}}
                            </span>
                                <ul>
                                    <li *ngFor="let log of log.params | keyvalue"
                                        [class.hidden]="hideDataRow(log.key)">
                                    <span *ngIf="log.key === 'addedAt' || log.key === 'expirationDate' || log.key === 'activeFromDate' || log.key === 'startDate' || log.key === 'createdAt' || log.key === 'exitDate' || log.key === 'entranceDate' || log.key === 'unsuspendedAt'">
                                        <b>{{log.key|translate}}:</b> {{log.value|date: 'dd.MM.y HH:mm:ss': 'UTC+' + log.timezoneOffset: locale}}
                                    </span>
                                    <span *ngIf="log.key !== 'voucher' && log.key !== 'addedAt' && log.key !== 'expirationDate' && log.key !== 'activeFromDate' && log.key !== 'startDate' && log.key !== 'createdAt' && log.key !== 'exitDate' && log.key !== 'entranceDate' && log.key !== 'unsuspendedAt'">
                                        <b>{{log.key|translate}}:</b> {{log.value}}
                                            <span *ngIf="log.value === '' && log.key === 'serviceName'">{{'All services'|translate}}</span>
                                    </span>
                                        <span *ngIf="log.key === 'voucher'">
                                            {{'Voucher'|translate}}
                                        </span>
                                        <ul *ngIf="log.key === 'voucher'">
                                            <li>
                                                <b>{{'Name'|translate}}:</b> {{log.value.name}}
                                            </li>
                                            <li>
                                                <b>{{'Open day voucher'|translate}}:</b> <span *ngIf="log.value.forOpenDay"> {{'Yes'|translate}}</span>
                                                <span *ngIf="!log.value.forOpenDay"> {{'No'|translate}}</span>
                                            </li>
                                            <li>
                                                <b>{{'MultiSport'|translate}}:</b> <span *ngIf="log.value.multisport"> {{'Yes'|translate}}</span>
                                                <span *ngIf="!log.value.multisport"> {{'No'|translate}}</span>
                                            </li>
                                            <li>
                                                <b>{{'MediCover'|translate}}:</b> <span *ngIf="log.value.medicover"> {{'Yes'|translate}}</span>
                                                <span *ngIf="!log.value.medicover"> {{'No'|translate}}</span>
                                            </li>
                                            <li><b>{{'Items'|translate}}</b>
                                                <ul>
                                                    <li *ngFor="let vItem of log.value.items">{{vItem.balance}} x {{vItem.serviceName}}</li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
        <!-- / CONTENT -->
<!--    </div>-->
</div>
